module.exports = __webpack_public_path__ + "img/flux_previsionnel.3ac7f539.jpg";